var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{attrs:{"name":"fade","tag":"div"}},_vm._l(([_vm.index]),function(i){return _c('div',{key:i},[_c('p',[_vm._v(_vm._s(_vm.currentText))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }